import { useSignal } from "@preact/signals-react";
import Board from "componentsv2/board/Board";
import { layout as layoutGuest } from "./guestLayout";

function Guests({ globalSearch }) {
  const layout = layoutGuest();
  const currentView = useSignal("list");
  return <Board layout={layout} currentView={currentView} />;
}

export default Guests;
